import axios from 'axios'
import { getBillingApiBaseUrl } from './billingApiBaseUrl'
import { getAuthToken } from './auth'

/** Web 积分收银：支付宝当面付扫码（路由与主站一致，基址同 open 域） */
export const API_CLIENT_TYPE_ALIPAY_SCAN = 'wechat-h5-miniapp-web'

function applyAlipayScanClientType(config) {
  const url = String((config && config.url) || '')
  if (!/\/vip-orders\b|\/asset\/score-order\//.test(url)) return
  if (!config.headers) config.headers = {}
  if (!config.headers['Client-Type']) {
    config.headers['Client-Type'] = API_CLIENT_TYPE_ALIPAY_SCAN
  }
}

const billingApi = axios.create({
  baseURL: getBillingApiBaseUrl(),
  timeout: 60000
})

billingApi.interceptors.request.use(
  config => {
    const token = getAuthToken()
    if (!config.headers) config.headers = {}
    if (token) {
      config.headers.Authorization = token
    }
    applyAlipayScanClientType(config)
    return config
  },
  err => Promise.reject(err)
)

billingApi.interceptors.response.use(
  res => res.data,
  err => Promise.reject(err)
)

export default billingApi
